<ion-app class="{{environment.APP_VERSION}}">
  <div class="offline-banner" *ngIf="!(networkService.isOnline$() | async)">
    <ion-icon name="cloud-offline-outline"></ion-icon>
    <span>{{ 'Offline mode - activities will be saved locally' | translate }}</span>
  </div>

  <ng-container *ngIf="initialAuthCheckDone; else loading">
    <ion-split-pane contentId="main-content">
      <ion-menu contentId="main-content" type="overlay" id="main-menu">
        <ion-content>
          <img src="/assets/icon/banner.png" class="banner" *ngIf="false">
  
          <ion-list>
            <ion-item lines="none" class="langSelectorFlag" *ngIf="currentLang">
              <ion-button slot="end" id="lang-selector-bt" fill="clear" color="dark">
                <span slot="start" [innerHTML]="currentLang['prefix']" style="margin-right: 1em; width: 1em;"></span>
                <ion-label>{{ currentLang['name'] }}</ion-label>
              </ion-button>
              <ion-modal trigger="lang-selector-bt" #modalLangSelector>
                <ng-template>
                  <app-select-search class="ion-page" title="{{ 'Language' | translate }}" [enableFilter]="false"
                    [items]="languagesSortedbyName" [selectedItem]="currentLang['id']"
                    (selectionChange)="langSelectionChanged($event)" (selectionCancel)="modalLangSelector.dismiss()"
                    (searchChange)="langSearchChanged($event)"></app-select-search>
                </ng-template>
              </ion-modal>
            </ion-item>
          </ion-list>
  
          <ion-list *ngIf="isLoggedIn && userService.user">
            <ng-container *ngIf="userService.user.organization?.id">
              <ion-list-header *ngIf="userService.user.organization">{{ userService.user.organization.name
                }}</ion-list-header>
              <ion-item lines="none">
                <ion-label>
                  {{ userService.user.firstName }} {{ userService.user.lastName }}<br>
                  <span style="opacity: 0.4;">{{ userService.user.identifier }}</span>
                </ion-label>
              </ion-item>
            </ng-container>
            <ng-container *ngIf="!userService.user.organization?.id">
              <ion-list-header>{{ userService.user.firstName }} {{ userService.user.lastName }}</ion-list-header>
              <ion-item lines="none">
                <ion-label style="opacity: 0.6;">{{ userService.user.identifier }}</ion-label>
              </ion-item>
            </ng-container>
  
            <!-- Refuge benevole shortcuts -->
            <ion-menu-toggle *ngIf="platform.is('hybrid')">
              <ion-item lines="none" button (click)="shareApp()">
                <ion-icon slot="start" name="share-social-outline" size="large"></ion-icon>
                <ion-label>{{ 'Share the app with my friends' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceRefuge' && (userService?.user?.organizationMember?.isRoleAdmin || userService?.user?.organizationMember?.isBenevoleWalker)">
              <ion-item lines="none" button [routerLink]="['/organization-flowcontrol']">
                <ion-icon slot="start" name="journal-outline" size="large"></ion-icon>
                <ion-label>{{ 'Tracking' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceRefuge' && (userService?.user?.organizationMember?.isRoleAdmin || userService?.user?.organizationMember?.isBenevoleWalker)">
              <ion-item lines="none" button [routerLink]="['/organization-walking']">
                <ion-icon slot="start" name="paw-outline" size="large"></ion-icon>
                <ion-label>{{ 'Walks' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ng-container *ngIf="['SonEspaceSante', 'SonEspaceEleveur'].includes(environment.APP_VERSION) || !userService?.user?.organizationMember?.isOnlyBenevoleWalker()">

              <!-- Group: Navigation -->
              <div class="menu-group-header"><span>{{ 'Navigation' | translate }}</span></div>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/']">
                  <ion-icon slot="start" name="home-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Homepage' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/animal-list']">
                  <ion-icon slot="start" name="paw-outline" size="large"></ion-icon>
                  <ion-label>{{ (environment.APP_VERSION == 'SonEspacePension' ? 'Pensions' : 'Pets') | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/event-list']">
                  <ion-icon slot="start" name="calendar-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Calendar' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <ion-item lines="none" button (click)="discussionsCB($event)" href="#">
                  <ion-icon slot="start" name="chatbox-ellipses" size="large" class="chat"></ion-icon>
                  <ion-label>{{ 'Discussions' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>

              <!-- Group: Health & tracking -->
              <div class="menu-group-header"><span>{{ 'Health & tracking' | translate }}</span></div>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/activities/activity-history']">
                  <ion-icon slot="start" name="fitness-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Activities' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle *ngIf="['SonEspaceSante', 'SonEspaceEleveur', 'SonEspaceRefuge', 'SonEspacePension'].includes(environment.APP_VERSION)">
                <ion-item lines="none" button [routerLink]="['/heart-rate']">
                  <ion-icon slot="start" name="heart-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Heart rate' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle *ngIf="['SonEspaceSante', 'SonEspaceEleveur'].includes(environment.APP_VERSION)">
                <ion-item lines="none" button [routerLink]="['/kibblechat']">
                  <ion-icon slot="start" name="restaurant-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Analyze kibble' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>

              <!-- Group: Management -->
              <div class="menu-group-header"><span>{{ 'Management' | translate }}</span></div>
              <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceEleveur'">
                <ion-item lines="none" button [routerLink]="['/litter-list']">
                  <ion-icon slot="start" name="logo-tableau" size="large"></ion-icon>
                  <ion-label>{{ 'Litters' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceRefuge'">
                <ion-item lines="none" button [routerLink]="['/plan']">
                  <ion-icon slot="start" name="map-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Plan' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle *ngIf="['SonEspaceSante', 'SonEspaceEleveur', 'SonEspaceRefuge', 'SonEspacePension'].includes(environment.APP_VERSION)">
                <ion-item lines="none" button [routerLink]="['/pharmacy-product-list']">
                  <ion-icon slot="start" name="medkit-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/clinic-contact-list']">
                  <ion-icon slot="start" name="storefront-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/compta-invoices-list']">
                  <ion-icon slot="start" name="cash-outline" size="large"></ion-icon>
                  <ion-label>{{ (environment.APP_VERSION == 'SonEspaceRefuge' ? 'Accounting' : (userService.user.organization?.id ? 'Accounting' : 'Invoices')) | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/animal-share-list']">
                  <ion-icon slot="start" name="share-social-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Shares' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>

            </ng-container>

            <!-- Group: Account -->
            <div class="menu-group-header"><span>{{ 'Account' | translate }}</span></div>
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/user-profile-update']">
                <ion-icon slot="start" name="person-outline" size="large"></ion-icon>
                <ion-label>{{ 'Profile' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="userService.user.isSuperuser">
              <ion-item lines="none" button [routerLink]="['/dashboard']">
                <ion-icon slot="start" name="stats-chart-outline" size="large"></ion-icon>
                <ion-label>{{ 'Dashboard' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="userService.user.isStaff">
              <ion-item lines="none" button [routerLink]="['/newsletter-list']">
                <ion-icon slot="start" name="mail-outline" size="large"></ion-icon>
                <ion-label>{{ 'Newsletters' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <!-- Group: Organization -->
            <ng-container *ngIf="['SonEspaceRefuge', 'SonEspaceEleveur', 'SonEspacePension'].includes(environment.APP_VERSION) && !userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
              <div class="menu-group-header"><span>{{ 'Organization' | translate }}</span></div>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/organization-fiche']">
                  <ion-icon slot="start" name="business-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Organization' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <ion-item lines="none" button [routerLink]="['/organization-member-list']">
                  <ion-icon slot="start" name="people-outline" size="large"></ion-icon>
                  <ion-label>{{ 'The team' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspacePension'">
                <ion-item lines="none" button [routerLink]="['/organization-documents']">
                  <ion-icon slot="start" name="document-text-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Organization documents' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceRefuge'">
                <ion-item lines="none" button [routerLink]="['/organization-fosterfamily-list']">
                  <ion-icon slot="start" name="bonfire-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Foster families' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceRefuge'">
                <ion-item lines="none" button [routerLink]="['/organization-stats']">
                  <ion-icon slot="start" name="stats-chart-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Statistics' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle *ngIf="['SonEspaceEleveur', 'SonEspacePension', 'SonEspaceRefuge'].includes(environment.APP_VERSION)">
                <ion-item lines="none" button [routerLink]="['/organization-subscription']">
                  <ion-icon slot="start" name="card-outline" size="large"></ion-icon>
                  <ion-label>{{ 'Subscription' | translate }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ng-container>

            <!-- Group: Support -->
            <div class="menu-group-header"><span>{{ 'Support' | translate }}</span></div>
            <ion-menu-toggle>
              <ion-item lines="none" (click)="menuCtrl.close();" [routerLink]="['/contact']">
                <ion-icon slot="start" name="mail-outline" size="large"></ion-icon>
                <ion-label>{{ 'Contact' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" (click)="menuCtrl.close();" [routerLink]="['/mentions-legales']">
                <ion-icon slot="start" name="information-circle-outline" size="large"></ion-icon>
                <ion-label>{{ 'Legal information' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button (click)="logout()" class="menu-logout">
                <ion-icon slot="start" name="log-out-outline" color="danger" size="large"></ion-icon>
                <ion-label>{{ 'Logout' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>

          <ion-list *ngIf="!isLoggedIn" style="margin-top: 3em;">
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/login']">
                <ion-icon slot="start" name="arrow-forward-circle-outline" color="success" size="large"></ion-icon>
                <ion-label>{{ 'Log in' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceSante'">
              <ion-item lines="none" button [routerLink]="['/user-profile-create']">
                <ion-icon slot="start" name="add-circle-outline" size="large"></ion-icon>
                <ion-label>{{ 'Create an account' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>
        </ion-content>
      </ion-menu>
      <div id="main-content" class="ion-page">
        <ion-router-outlet [class.hideTabBar]="!showTabBar"></ion-router-outlet>

        <!-- ═══════════════════════════════════════════════════════ -->
        <!-- SonEspaceSante                                          -->
        <!-- ═══════════════════════════════════════════════════════ -->
        <ng-container *ngIf="environment.APP_VERSION === 'SonEspaceSante' && showTabBar">
          <div class="sonEspaceSante-tabs" id="sonEspaceSante-tabs">
            <a tab="homepage" [routerLink]="['/']">
              <ion-icon name="home" color="dark"></ion-icon>
              <ion-label>{{ 'Homepage' | translate }}</ion-label>
            </a>
            <a tab="logbook" [routerLink]="['/logbook']">
              <ion-icon name="newspaper" color="dark"></ion-icon>
              <ion-label>{{ 'Notebook' | translate }}</ion-label>
            </a>
            <a tab="animal" [routerLink]="['/animal-list']">
              <ion-icon name="paw" color="dark"></ion-icon>
              <ion-label>{{ 'Pets' | translate }}</ion-label>
            </a>
            <a tab="event" [routerLink]="['/event-list']">
              <ion-icon name="calendar" color="dark"></ion-icon>
              <ion-label>{{ 'Agenda' | translate }}</ion-label>
            </a>
            <a tab="pharmacy" [routerLink]="['/pharmacy-product-list']" class="desktop-only">
              <ion-icon name="medkit" color="dark"></ion-icon>
              <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
            </a>
            <a tab="activities" [routerLink]="['/activities/activity-history']" class="desktop-only">
              <ion-icon name="fitness" color="dark"></ion-icon>
              <ion-label>{{ 'Activities' | translate }}</ion-label>
            </a>
            <a tab="invoices" [routerLink]="['/compta-invoices-list']" class="desktop-only">
              <ion-icon name="cash-outline" color="dark"></ion-icon>
              <ion-label>{{ 'Invoices' | translate }}</ion-label>
            </a>
            <a tab="discussion" (click)="discussionsCB($event)" href="#" class="mobile-only">
              <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
              <ion-label>{{ 'Chat' | translate }}</ion-label>
            </a>
            <a tab="discussion" (click)="discussionsCB($event)" href="#" class="desktop-only">
              <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
              <ion-label>{{ 'Chat' | translate }}</ion-label>
            </a>
            <a tab="more" id="more-tab-button" class="mobile-only">
              <ion-icon name="ellipsis-horizontal" color="dark"></ion-icon>
              <ion-label>{{ 'more' | translate }}</ion-label>
            </a>
            <a tab="more" id="plus-desktop-tab-button" class="desktop-only">
              <ion-icon name="ellipsis-horizontal" color="dark"></ion-icon>
              <ion-label>{{ 'more' | translate }}</ion-label>
            </a>
          </div>
          <ion-popover trigger="plus-desktop-tab-button" side="top" alignment="end" dismissOnSelect="true" cssClass="more-tabs-popover" arrow="false">
            <ng-template>
              <ion-content><ion-list lines="none">
                <ion-item button [routerLink]="['/heart-rate']" detail="false">
                  <ion-icon name="heart-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Heart rate' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/kibblechat']" detail="false">
                  <ion-icon name="nutrition-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Analyze kibble' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/clinic-contact-list']" detail="false">
                  <ion-icon name="storefront-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
              </ion-list></ion-content>
            </ng-template>
          </ion-popover>
          <ion-popover trigger="more-tab-button" side="top" alignment="end" dismissOnSelect="true" cssClass="more-tabs-popover" arrow="false">
            <ng-template>
              <ion-content><ion-list lines="none">
                <ion-item button [routerLink]="['/kibblechat']" detail="false">
                  <ion-icon name="nutrition-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Analyze kibble' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/pharmacy-product-list']" detail="false">
                  <ion-icon name="medkit-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/activities/activity-history']" detail="false">
                  <ion-icon name="fitness-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Activities' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/heart-rate']" detail="false">
                  <ion-icon name="heart-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Heart rate' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/compta-invoices-list']" detail="false">
                  <ion-icon name="cash-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Invoices' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/clinic-contact-list']" detail="false">
                  <ion-icon name="storefront-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
              </ion-list></ion-content>
            </ng-template>
          </ion-popover>
        </ng-container>

        <!-- ═══════════════════════════════════════════════════════ -->
        <!-- SonEspaceEleveur                                        -->
        <!-- ═══════════════════════════════════════════════════════ -->
        <ng-container *ngIf="environment.APP_VERSION === 'SonEspaceEleveur' && showTabBar">
          <div class="sonEspaceSante-tabs" id="sonEspaceSante-tabs">
            <a tab="homepage" [routerLink]="['/']">
              <ion-icon name="home" color="dark"></ion-icon>
              <ion-label>{{ 'Homepage' | translate }}</ion-label>
            </a>
            <a tab="logbook" [routerLink]="['/logbook']">
              <ion-icon name="newspaper" color="dark"></ion-icon>
              <ion-label>{{ 'Notebook' | translate }}</ion-label>
            </a>
            <a tab="animal" [routerLink]="['/animal-list']">
              <ion-icon name="paw" color="dark"></ion-icon>
              <ion-label>{{ 'Pets' | translate }}</ion-label>
            </a>
            <a tab="event" [routerLink]="['/event-list']">
              <ion-icon name="calendar" color="dark"></ion-icon>
              <ion-label>{{ 'Agenda' | translate }}</ion-label>
            </a>
            <a tab="litter" [routerLink]="['/litter-list']" class="desktop-only">
              <ion-icon name="logo-tableau" color="dark"></ion-icon>
              <ion-label>{{ 'Litters' | translate }}</ion-label>
            </a>
            <a tab="pharmacy" [routerLink]="['/pharmacy-product-list']" class="desktop-only">
              <ion-icon name="medkit" color="dark"></ion-icon>
              <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
            </a>
            <a tab="activities" [routerLink]="['/activities/activity-history']" class="desktop-only">
              <ion-icon name="fitness" color="dark"></ion-icon>
              <ion-label>{{ 'Activities' | translate }}</ion-label>
            </a>
            <a tab="invoices" [routerLink]="['/compta-invoices-list']" class="desktop-only">
              <ion-icon name="cash-outline" color="dark"></ion-icon>
              <ion-label>{{ 'Accounting' | translate }}</ion-label>
            </a>
            <a tab="discussion" (click)="discussionsCB($event)" href="#" class="mobile-only">
              <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
              <ion-label>{{ 'Chat' | translate }}</ion-label>
            </a>
            <a tab="discussion" (click)="discussionsCB($event)" href="#" class="desktop-only">
              <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
              <ion-label>{{ 'Chat' | translate }}</ion-label>
            </a>
            <a tab="more" id="more-tab-button" class="mobile-only">
              <ion-icon name="ellipsis-horizontal" color="dark"></ion-icon>
              <ion-label>{{ 'more' | translate }}</ion-label>
            </a>
            <a tab="more" id="plus-desktop-tab-button" class="desktop-only">
              <ion-icon name="ellipsis-horizontal" color="dark"></ion-icon>
              <ion-label>{{ 'more' | translate }}</ion-label>
            </a>
          </div>
          <ion-popover trigger="plus-desktop-tab-button" side="top" alignment="end" dismissOnSelect="true" cssClass="more-tabs-popover" arrow="false">
            <ng-template>
              <ion-content><ion-list lines="none">
                <ion-item button [routerLink]="['/heart-rate']" detail="false">
                  <ion-icon name="heart-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Heart rate' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/kibblechat']" detail="false">
                  <ion-icon name="nutrition-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Analyze kibble' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/clinic-contact-list']" detail="false">
                  <ion-icon name="storefront-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
              </ion-list></ion-content>
            </ng-template>
          </ion-popover>
          <ion-popover trigger="more-tab-button" side="top" alignment="end" dismissOnSelect="true" cssClass="more-tabs-popover" arrow="false">
            <ng-template>
              <ion-content><ion-list lines="none">
                <ion-item button [routerLink]="['/litter-list']" detail="false">
                  <ion-icon name="logo-tableau" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Litters' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/kibblechat']" detail="false">
                  <ion-icon name="nutrition-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Analyze kibble' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/pharmacy-product-list']" detail="false">
                  <ion-icon name="medkit-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/activities/activity-history']" detail="false">
                  <ion-icon name="fitness-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Activities' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/heart-rate']" detail="false">
                  <ion-icon name="heart-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Heart rate' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/compta-invoices-list']" detail="false">
                  <ion-icon name="cash-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Accounting' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/clinic-contact-list']" detail="false">
                  <ion-icon name="storefront-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
              </ion-list></ion-content>
            </ng-template>
          </ion-popover>
        </ng-container>

        <!-- ═══════════════════════════════════════════════════════ -->
        <!-- SonEspaceRefuge                                         -->
        <!-- ═══════════════════════════════════════════════════════ -->
        <ng-container *ngIf="environment.APP_VERSION === 'SonEspaceRefuge' && showTabBar">
          <div class="sonEspaceSante-tabs" id="sonEspaceSante-tabs">
            <a tab="homepage" [routerLink]="['/']" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
              <ion-icon name="home" color="dark"></ion-icon>
              <ion-label>{{ 'Homepage' | translate }}</ion-label>
            </a>
            <a tab="animal" [routerLink]="['/animal-list']" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
              <ion-icon name="paw" color="dark"></ion-icon>
              <ion-label>{{ 'Pets' | translate }}</ion-label>
            </a>
            <a tab="event" [routerLink]="['/event-list']" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
              <ion-icon name="calendar" color="dark"></ion-icon>
              <ion-label>{{ 'Agenda' | translate }}</ion-label>
            </a>
            <a tab="flowcontrol" [routerLink]="['/organization-flowcontrol']" *ngIf="userService?.user?.organizationMember?.isBenevoleWalker || userService?.user?.organizationMember?.isRoleAdmin">
              <ion-icon name="journal" color="dark"></ion-icon>
              <ion-label>{{ 'Tracking' | translate }}</ion-label>
            </a>
            <a tab="plan" [routerLink]="['/plan']" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()" class="desktop-only">
              <ion-icon name="map" color="dark"></ion-icon>
              <ion-label>{{ 'Plan' | translate }}</ion-label>
            </a>
            <a tab="invoices" [routerLink]="['/compta-invoices-list']" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()" class="desktop-only">
              <ion-icon name="cash-outline" color="dark"></ion-icon>
              <ion-label>{{ 'Accounting' | translate }}</ion-label>
            </a>
            <a tab="discussion" (click)="discussionsCB($event)" href="#" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()" class="mobile-only">
              <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
              <ion-label>{{ 'Chat' | translate }}</ion-label>
            </a>
            <a tab="discussion" (click)="discussionsCB($event)" href="#" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()" class="desktop-only">
              <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
              <ion-label>{{ 'Chat' | translate }}</ion-label>
            </a>
            <a tab="more" id="more-tab-button" class="mobile-only" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
              <ion-icon name="ellipsis-horizontal" color="dark"></ion-icon>
              <ion-label>{{ 'more' | translate }}</ion-label>
            </a>
            <a tab="more" id="plus-desktop-tab-button" class="desktop-only" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
              <ion-icon name="ellipsis-horizontal" color="dark"></ion-icon>
              <ion-label>{{ 'more' | translate }}</ion-label>
            </a>
          </div>
          <ion-popover trigger="plus-desktop-tab-button" side="top" alignment="end" dismissOnSelect="true" cssClass="more-tabs-popover" arrow="false">
            <ng-template>
              <ion-content><ion-list lines="none">
                <ion-item button [routerLink]="['/pharmacy-product-list']" detail="false">
                  <ion-icon name="medkit-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/organization-member-list']" detail="false">
                  <ion-icon name="people-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'The team' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/clinic-contact-list']" detail="false">
                  <ion-icon name="storefront-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
              </ion-list></ion-content>
            </ng-template>
          </ion-popover>
          <ion-popover trigger="more-tab-button" side="top" alignment="end" dismissOnSelect="true" cssClass="more-tabs-popover" arrow="false">
            <ng-template>
              <ion-content><ion-list lines="none">
                <ion-item button [routerLink]="['/pharmacy-product-list']" detail="false">
                  <ion-icon name="medkit-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/organization-member-list']" detail="false">
                  <ion-icon name="people-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'The team' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/compta-invoices-list']" detail="false">
                  <ion-icon name="cash-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Accounting' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/clinic-contact-list']" detail="false">
                  <ion-icon name="storefront-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/plan']" detail="false">
                  <ion-icon name="map-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Plan' | translate }}</ion-label>
                </ion-item>
              </ion-list></ion-content>
            </ng-template>
          </ion-popover>
        </ng-container>

        <!-- ═══════════════════════════════════════════════════════ -->
        <!-- SonEspacePension                                        -->
        <!-- ═══════════════════════════════════════════════════════ -->
        <ng-container *ngIf="environment.APP_VERSION === 'SonEspacePension' && showTabBar">
          <div class="sonEspaceSante-tabs" id="sonEspaceSante-tabs">
            <a tab="homepage" [routerLink]="['/']">
              <ion-icon name="home" color="dark"></ion-icon>
              <ion-label>{{ 'Homepage' | translate }}</ion-label>
            </a>
            <a tab="logbook" [routerLink]="['/logbook']">
              <ion-icon name="newspaper" color="dark"></ion-icon>
              <ion-label>{{ 'Logbook' | translate }}</ion-label>
            </a>
            <a tab="animal" [routerLink]="['/animal-list']">
              <ion-icon name="paw" color="dark"></ion-icon>
              <ion-label>{{ 'Pensions' | translate }}</ion-label>
            </a>
            <a tab="event" [routerLink]="['/event-list']">
              <ion-icon name="calendar" color="dark"></ion-icon>
              <ion-label>{{ 'Agenda' | translate }}</ion-label>
            </a>
            <a tab="documents" [routerLink]="['/organization-documents']" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
              <ion-icon name="document-text" color="dark"></ion-icon>
              <ion-label>{{ 'Documents' | translate }}</ion-label>
            </a>
            <a tab="invoices" [routerLink]="['/compta-invoices-list']" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()" class="desktop-only">
              <ion-icon name="cash-outline" color="dark"></ion-icon>
              <ion-label>{{ 'Accounting' | translate }}</ion-label>
            </a>
            <a tab="team" [routerLink]="['/organization-member-list']" *ngIf="!userService?.user?.organizationMember?.isOnlyBenevoleWalker()" class="desktop-only">
              <ion-icon name="people" color="dark"></ion-icon>
              <ion-label>{{ 'The team' | translate }}</ion-label>
            </a>
            <a tab="discussion" (click)="discussionsCB($event)" href="#" class="mobile-only">
              <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
              <ion-label>{{ 'Chat' | translate }}</ion-label>
            </a>
            <a tab="discussion" (click)="discussionsCB($event)" href="#" class="desktop-only">
              <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
              <ion-label>{{ 'Chat' | translate }}</ion-label>
            </a>
            <a tab="more" id="more-tab-button" class="mobile-only">
              <ion-icon name="ellipsis-horizontal" color="dark"></ion-icon>
              <ion-label>{{ 'more' | translate }}</ion-label>
            </a>
            <a tab="more" id="plus-desktop-tab-button" class="desktop-only">
              <ion-icon name="ellipsis-horizontal" color="dark"></ion-icon>
              <ion-label>{{ 'more' | translate }}</ion-label>
            </a>
          </div>
          <ion-popover trigger="plus-desktop-tab-button" side="top" alignment="end" dismissOnSelect="true" cssClass="more-tabs-popover" arrow="false">
            <ng-template>
              <ion-content><ion-list lines="none">
                <ion-item button [routerLink]="['/organization-fiche']" detail="false">
                  <ion-icon name="business-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Organization' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/clinic-contact-list']" detail="false">
                  <ion-icon name="storefront-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
              </ion-list></ion-content>
            </ng-template>
          </ion-popover>
          <ion-popover trigger="more-tab-button" side="top" alignment="end" dismissOnSelect="true" cssClass="more-tabs-popover" arrow="false">
            <ng-template>
              <ion-content><ion-list lines="none">
                <ion-item button [routerLink]="['/organization-fiche']" detail="false">
                  <ion-icon name="business-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Organization' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/organization-member-list']" detail="false">
                  <ion-icon name="people-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'The team' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/compta-invoices-list']" detail="false">
                  <ion-icon name="cash-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Accounting' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/pharmacy-product-list']" detail="false">
                  <ion-icon name="medkit-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
                </ion-item>
                <ion-item button [routerLink]="['/clinic-contact-list']" detail="false">
                  <ion-icon name="storefront-outline" slot="start" color="medium"></ion-icon>
                  <ion-label>{{ 'Veterinarians' | translate }}</ion-label>
                </ion-item>
              </ion-list></ion-content>
            </ng-template>
          </ion-popover>
        </ng-container>
      </div>
    </ion-split-pane>
  </ng-container>

  <app-recorder-widget></app-recorder-widget>
  
  <ng-template #loading>
    <ion-content>
      <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    </ion-content>
  </ng-template>
</ion-app>